/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Access_Optional_AddonInputs */

const fr_membership_access_optional_addon = /** @type {(inputs: Membership_Access_Optional_AddonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible en option`)
};

/**

* @param {Membership_Access_Optional_AddonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_access_optional_addon = /** @type {((inputs?: Membership_Access_Optional_AddonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Access_Optional_AddonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_access_optional_addon(inputs)
});